import React, { useEffect } from 'react'
import { CustomPicker } from 'react-color'
import { Alpha, Checkboard, Hue, Saturation } from 'react-color/lib/components/common'
import SketchPresetColors from 'react-color/lib/components/sketch/SketchPresetColors'
import SketchFields from 'react-color/lib/components/sketch/SketchFields'
import styles from './SketchColorPicker.module.sass'

type PresetColor = string | { color: string; title?: string }

const DEFAULT_PRESET_COLORS: PresetColor[] = [
  '#D0021B',
  '#F5A623',
  '#F8E71C',
  '#8B572A',
  '#7ED321',
  '#417505',
  '#BD10E0',
  '#9013FE',
  '#4A90E2',
  '#50E3C2',
  '#B8E986',
  '#000000',
  '#4A4A4A',
  '#9B9B9B',
  '#FFFFFF',
]

const sliderStyle = {
  borderRadius: '2px',
  boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)',
}

const saturationStyle = {
  borderRadius: '3px',
  boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)',
}

const SketchColorPicker = ({
  width = 200,
  rgb,
  hex,
  hsl,
  hsv,
  onChange,
  onSwatchHover,
  disableAlpha = false,
  presetColors = DEFAULT_PRESET_COLORS,
  className = '',
  alertText = null,
}: any) => {
  useEffect(() => {
    if (typeof document === 'undefined') return

    // Evita la selezione involontaria di testo/elementi durante il drag nel color picker.
    document.body.classList.add('editor-color-picker-open')

    return () => {
      document.body.classList.remove('editor-color-picker-open')
    }
  }, [])

  return (
    <div style={{ width }} className={`sketch-picker ${styles.root} ${className || ''}`}>
      <div className={styles.saturationWrap}>
        <Saturation style={saturationStyle} hsl={hsl} hsv={hsv} onChange={onChange} />
      </div>
      <div className={`${styles.controls} flexbox-fix`}>
        <div className={styles.sliders}>
          <div className={styles.hue}>
            <Hue style={sliderStyle} hsl={hsl} onChange={onChange} />
          </div>
          {!disableAlpha && (
            <div className={styles.alpha}>
              <Alpha style={sliderStyle} rgb={rgb} hsl={hsl} onChange={onChange} />
            </div>
          )}
        </div>
        <div className={styles.color}>
          <Checkboard />
          <div
            className={styles.activeColor}
            style={{ background: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` }}
          />
        </div>
      </div>
      <SketchFields rgb={rgb} hsl={hsl} hex={hex} onChange={onChange} disableAlpha={disableAlpha} />
      {!!alertText && <div className={styles.alert}>{alertText}</div>}
      <SketchPresetColors colors={presetColors} onClick={onChange} onSwatchHover={onSwatchHover} />
    </div>
  )
}

export default CustomPicker(SketchColorPicker)
